import Loadable from 'app/components/Loadable';
import { lazy } from 'react';

const ContractList = Loadable(lazy(() => import('./ContractList')));
const EGPContractBOQRate = Loadable(lazy(() => import('./EGPContractBOQRate')));

const contractListRoutes = [
  {
    path: '/contractList',
    element: <ContractList />,
  },
  {
    path: '/EGPContractBOQRate',
    element: <EGPContractBOQRate />,
  }

];

export default contractListRoutes;